import { memo } from 'react'
import { styled } from '@mui/material'
import { useRecentUsers } from '$logic/room-list/room-list-search.react-hook'
import { openUserProfile } from '$logic/router'
import { RecentUserItem } from '$common/recent-user-item'
import { HIDE_SCROLLBAR_CLASS } from '$setup/style/constants'
import { Scroller } from '$common/scroller'

export const RecentUsers = memo(function () {
  const recentUsers = useRecentUsers()
  console.log({ recentUsers })
  if (!recentUsers.length) return null
  return (
    <Scroller>
      <Root>
        {recentUsers.map(({ userId }) => (
          <RecentUserItem
            key={userId}
            userId={userId}
            onSelect={() => openUserProfile(userId)}
          />
        ))}
      </Root>
    </Scroller>
  )
})

const Root = styled('div')`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.neutral000};
`
